import React, { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";
import Message from "./Message";
import { FaTrashAlt } from "react-icons/fa";
import permissions from "../data/permissions";
import { notify } from "./notify";
import { logout } from "../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

const Member = ({ member, order, clinicId }) => {
  const [newPermissionId, setNewPermissionId] = useState(member.permissionId);
  const [allowUpdate, setAllowUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const deleteMember = async () => {
    if (
      window.confirm(
        `You will remove ${member.firstName} ${member.lastName}. Are you sure?`,
      )
    ) {
      try {
        setLoading(true);

        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
        const { data } = await axios.put(
          `/api/clinics/${clinicId}/removeClinicMember`,
          { memberId: member.memberId },
          config,
        );
        if (data.message === "DELETED") {
          dispatch({ type: "CLINIC_DETAILS_RESET" });
          setLoading(false);

          notify({
            title: "Member removed successfully",
            message: <p className="lead">Data saved.</p>,
            type: "success",
            duration: 4000,
          });
        }
      } catch (error) {
        const message =
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message;
        if (message === "Not authorized, token failed") {
          dispatch(logout());
        }
        setError(message);
      }
    }
  };
  useEffect(() => {
    member.permissionId = newPermissionId;
    setAllowUpdate(true);
  }, [newPermissionId]);
  return (
    <>
      {error && (
        <Message
          children={`Remove Member Error: ${error}`}
          variant={`danger`}
          setMessage={setError}
        />
      )}
      <Card className=" border-dark mb-3 text-primary">
        <Card.Header className="p-3">
          <Row>
            <Col className="col-sm-10">
              {member.firstName && member.lastName ? (
                <Card.Title>
                  <h4>{`${order}- ${member.firstName} ${member.lastName}`}</h4>
                </Card.Title>
              ) : (
                <Card.Title>
                  {`${order}- ${member.userEmail}`} <br />{" "}
                </Card.Title>
              )}
            </Col>
            {order > 1 && (
              <Col
                className="col-sm-2 text-danger"
                onClick={() => deleteMember(member)}
              >
                <FaTrashAlt />
              </Col>
            )}
          </Row>
        </Card.Header>
        <Card.Body>
          {order === 1 ? (
            <Message children={`The Owner of this clinic.`} variant={`info`} />
          ) : (
            <>
              <Form.Group controlId="permissionId">
                <Form.Label>Permission</Form.Label>
                <Form.Control
                  as="select"
                  value={newPermissionId}
                  onChange={(e) => setNewPermissionId(e.target.value)}
                  className="custom-select"
                  isValid={member.permissionId}
                  disabled
                >
                  {permissions.map((p) => (
                    <option key={p._id} disabled={p.disabled} value={p._id}>
                      {p.label}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default Member;
